import { render, staticRenderFns } from "./LogisView.vue?vue&type=template&id=0dba3b19"
import script from "./LogisView.vue?vue&type=script&lang=js"
export * from "./LogisView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports